import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Reserve } from './components/Reserve';
import { HowItWorks } from './components/HowItWorks';
import { TheWork } from './components/TheWork';
import { AshleyIntro } from './components/AshleyIntro';
import { SelectedVoices } from './components/SelectedVoices';
import { Begin } from './components/Begin';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-beige text-graphite" data-id="element-0" data-mp="2mlua4q7bnttt">
      <Header data-id="element-1" data-mp="2mndpmel5m0uj" />
      <main data-id="element-2" data-mp="2mjpuxc3z38e8">
        <Hero data-id="element-3" data-mp="2mjznn7gejtnm" />
        <Reserve data-id="element-4" data-mp="31agnimde2bie" />
        <HowItWorks data-id="element-5" data-mp="31ayr642drs0c" />
        <TheWork data-id="element-6" data-mp="31bi9vmzuukff" />
        <AshleyIntro data-id="element-7" data-mp="31c1jmgfcq2id" />
        <SelectedVoices data-id="element-8" data-mp="31cjk5p91r2w3" />
        <Begin data-id="element-9" data-mp="2wjgptewg3peu" />
      </main>
      <Footer data-id="element-10" data-mp="2wj8f9tnsow6t" />
    </div>;
}